import React, { useState, useEffect } from 'react';
import Page from '../../components/Page';
import { Icon, Breadcrumb, Form, Table, Button, Segment, Modal, Header, Message, Popup, Label, Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import useFetch from 'use-http';
import MyMenu from './menu';
import AccountProgress from '../../components/AccountProgress';
import { get, post, toWapi } from '../../util/api';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

let agentTypes = [
	{
		text: 'Admin',
		value: 'admin',
	},
	{
		text: 'Standart',
		value: 'standard',
	},
	{
		text: 'Agent',
		value: 'agent',
	},
	{
		text: 'Dev',
		value: 'dev',
	},
];

const fetch_config = { responseType: 'json', cachePolicy: 'no-cache' };
const fetch_config2 = {
	method: 'GET',
	headers: {
		'Content-Type': 'application/json',
	},
};
export default function ProductSettings() {
	const { t } = useTranslation();
	const [reload, setReload] = useState(0);
	const [loading2, setloading2] = useState(true);
	const [response2, setresponse2] = useState({});
	useEffect(() => {
		const checkAPI = async () => {
			try {
				const res = await fetch('/api/dahi/message/getLiveChat?2', fetch_config2);
				const data = await res.json();
				console.log('Direct API call response:', data);
				setloading2(false);
				setresponse2(data.result);
			} catch (err) {
				console.error('API call error:', err);
			}
		};

		checkAPI();
	}, [reload]);
	const { loading, response } = useFetch('/api/live/agent/list', fetch_config, [reload]);
	// Telefon bazlı gruplama (staticOptions.phone_groups) + multi durumu
	const product = useSelector((state) => state.product.live);
	const [pg, setPg] = useState(null);
	const [pgLoading, setPgLoading] = useState(false);
	const [pgError, setPgError] = useState(null);
	useEffect(() => {
		get('/dahi/message/phoneGroups')
			.then((res) => {
				if (res && res.success) setPg(res);
			})
			.catch(() => {});
	}, [reload]);
	const [sessionCounts, setSessionCounts] = useState({});
	useEffect(() => {
		get('/live/agent/sessionCounts').then((res) => {
			if (res && res.success) {
				const map = {};
				res.data.forEach((a) => { map[a.uid] = a.sessionCount; });
				setSessionCounts(map);
			}
		}).catch(() => {});
	}, [reload]);
	const [state, setState] = useState({
		showAdd: false,
		showUpdate: false,
		agentMail: '',
		agentPassword: '',
		agentConfirmPassword: '',
		agentType: 'agent',
		agentName: '',
		passworderror: false,
		error: null,
		deleteBtnClicked: false,
		addButton: t('add'),
		showPassword: true,
		agentGroups: [],
	});
	if (loading || loading2)
		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/settings`}>
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
					</Breadcrumb>
				}
				flex
			>
				<MyMenu activeItem="agent">
					<Page.Loader></Page.Loader>
				</MyMenu>
			</Page>
		);
	const data = response && response.data && response.data.agents;
	let live_chat_agents = response2 && response2.agents;
	let staticOptions = response2 && response2.staticOptions;
	let agentsData = _.filter(data, function (it) {
		return it.role !== 'viewer';
	});
	let viewersData = _.filter(data, function (it) {
		return it.role === 'viewer';
	});
	//const product = response && response.data && response.data.product;
	const user = response && response.data && response.data.user;
	const host = user.host === null || user.host === 'app.dialogtab';
	let agentlimit = (response && response.data && response.data.product && response.data.product.settings.agent_limit) || 0;
	let agentcount = agentsData.length + 1;
	let viewerscount = viewersData.length;
	const own_team_admin = user && user.extra && user.extra.team_admin;
	let own_live_agent = _.find(live_chat_agents, { id: user.extra.user_id });
	let own_team = own_live_agent && own_live_agent.team;
	let isTeam = staticOptions && staticOptions.teams;
	function handleAddAgents() {
		if (agentcount >= agentlimit) {
			setState({
				addError: true,
				addErrorMessage: t('addAgentErrorMessage'),
			});
		} else {
			reset();
			setState({
				current: 'add',
				currentviewer: false,
				agentType: 'agent',
				addButton: t('add'),
				agentMail: '',
				agentPassword: '',
				agentConfirmPassword: '',
				showPassword: true,
				agentName: '',
			});
		}
	}
	function handleAddViewers() {
		if (viewerscount >= 10) {
			setState({
				addError: true,
				addErrorMessage: "You can't add more than five viewers.",
			});
		} else {
			reset();
			setState({
				currentviewer: 'add',
				current: false,
				agentType: 'agent',
				addButton: 'Add',
				agentMail: '',
				agentPassword: '',
				agentConfirmPassword: '',
				showPassword: true,
				agentName: '',
			});
		}
	}
	function handleUpdateViewers(value) {
		setState({
			currentviewer: 'update',
			agentMail: value.mail,
			current: false,
			selectedAgentUid: value.uid,
			agentType: value.agentType,
			agentName: value.name,
			agentPassword: value.password,
			showPassword: false,
			user_id: value.user_id,
			addButton: t('update'),
		});
	}
	function handleUpdateAgents(value) {
		setState({
			current: 'update',
			currentviewer: false,
			agentGroups: value.groups || [],
			agentMail: value.mail,
			selectedAgentUid: value.uid,
			agentType: value.agentType,
			agentName: value.name,
			agentPassword: value.password,
			user_id: value.user_id,
			showPassword: false,
			addButton: t('update'),
		});
	}

	function reset() {
		setState({
			current: '',
			currentviewer: '',
			agentMail: '',
			agentPassword: '',
			agentConfirmPassword: '',
			agentType: 'agent',
			agentName: '',
			agentGroups: [],
			addButton: t('add'),
			passworderror: false,
			error: null,
		});
	}
	function validPassword() {
		let isTrue = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/.test(state.agentPassword);
		return isTrue;
	}
	function handleAddAgent() {
		let isTrue = validPassword();
		if (isTrue) {
			setState((state) => ({ ...state, passworderror: false }));

			fetch('/api/live/agent/add', {
				method: 'POST',
				body: JSON.stringify({
					role: state.agentType,
					email: state.agentMail,
					password: state.agentPassword,
					name: state.agentName,
					group: showGroups ? state.agentGroups || [] : undefined,
				}),
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						reset();
						setReload(reload + 1);
					} else {
						setState((state) => ({ ...state, error: data.pg ? 'Error' : '' + data.message }));
					}
				});
		} else {
			setState((state) => ({ ...state, passworderror: true }));
		}
	}
	function handleAddViewer() {
		let isTrue = validPassword();
		if (isTrue) {
			setState((state) => ({ ...state, passworderror: false }));

			fetch('/api/live/agent/add', {
				method: 'POST',
				body: JSON.stringify({
					role: 'viewer',
					email: state.agentMail,
					password: state.agentPassword,
					name: state.agentName,
				}),
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						reset();
						setReload(reload + 1);
					} else {
						setState((state) => ({ ...state, errorviewer: data.pg ? 'Error' : '' + data.message }));
					}
				});
		} else {
			setState((state) => ({ ...state, passworderror: true }));
		}
	}
	function handleUpdateAgent() {
		let isTrue = !state.agentPassword || validPassword(); // bos sifre = degistirme (liste sifre dondurmuyor)
		if (isTrue) {
			setState((state) => ({ ...state, passworderror: false }));
			fetch('/api/live/agent/update', {
				method: 'POST',
				body: JSON.stringify({
					uid: state.selectedAgentUid,
					role: state.agentType,
					email: state.agentMail,
					password: state.agentPassword,
					name: state.agentName,
					user_id: state.user_id,
					group: showGroups ? state.agentGroups || [] : undefined,
				}),
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						reset();
						setReload(reload + 1);
					} else {
						setState((state) => ({ ...state, error: data.pg ? 'Error' : '' + data.message }));
					}
				});
		} else {
			setState((state) => ({ ...state, passworderror: true }));
		}
	}
	function handleUpdateViewer() {
		let isTrue = !state.agentPassword || validPassword(); // bos sifre = degistirme (liste sifre dondurmuyor)
		if (isTrue) {
			setState((state) => ({ ...state, passworderror: false }));
			fetch('/api/live/agent/update', {
				method: 'POST',
				body: JSON.stringify({
					uid: state.selectedAgentUid,
					role: state.agentType,
					email: state.agentMail,
					password: state.agentPassword,
					name: state.agentName,
					user_id: state.user_id,
				}),
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.success) {
						reset();
						setReload(reload + 1);
					} else {
						setState((state) => ({ ...state, errorviewer: data.pg ? 'Error' : '' + data.message }));
					}
				});
		} else {
			setState((state) => ({ ...state, passworderror: true }));
		}
	}
	function handleDeleteAgent() {
		fetch('/api/live/agent/delete', {
			method: 'POST',
			body: JSON.stringify({ uid: state.selectedAgentUid, user_id: state.selectedAgentUser_id }),
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					reset();
					setReload(reload + 1);
				} else {
					setState((state) => ({ ...state, error: '' + data.message }));
				}
			});
	}

	function handleChange(e, { name, value }) {
		setState((state) => ({ ...state, [name]: value }));
	}
	function handleClickDelete() {
		handleDeleteAgent();
	}
	function openDeleteButton(value) {
		setState({ selectedAgentUid: value.uid, selectedAgentUser_id: value.user_id, deleteBtnClicked: true });
	}
	function closeDeleteButton() {
		setState({ deleteBtnClicked: false, goToSubs: false });
	}
	function renderSessions(uid) {
		return (
			<Link to={`/settings/agents/sessions/${uid}`}>
				<Label color={sessionCounts[uid] > 0 ? 'green' : 'grey'} size="tiny">
					<Icon name="computer" />
					{sessionCounts[uid] || 0}
				</Label>
			</Link>
		);
	}
	// Agent ekle/düzenle formu: düzenlemede tıklanan agent'ın hemen altındaki satırda, eklemede tablonun ilk satırında açılır
	function renderAgentForm() {
		return (
			<Form
				size="small"
				error={!!state.error}
				autoComplete="off"
				onSubmit={() => {
					if (!IS_UPDATE) handleAddAgent();
					else handleUpdateAgent();
				}}
			>
				<input autoComplete="false" name="" value="" type="email" style={{ display: 'none' }} />
				{state.error && <Message error size="small" content={'' + state.error} />}
				<Form.Group widths="equal">
					<Form.Input label={t('email')} placeholder="Email" name="agentMail" value={state.agentMail} onChange={handleChange} required type="email" />
					<Form.Dropdown label={t('type')} name="agentType" selection options={agentTypes} value={state.agentType} onChange={handleChange} />
					{showGroups && (
						<Form.Dropdown
							label={t('groups')}
							placeholder={t('groups')}
							name="agentGroups"
							selection
							multiple
							search
							options={groupOptions}
							value={state.agentGroups || []}
							onChange={handleChange}
						/>
					)}
					<Form.Input
						label={t('fullName')}
						placeholder={t('fullName')}
						name="agentName"
						value={state.agentName}
						onChange={handleChange}
						required={!IS_UPDATE}
						type="text"
					/>
					<Form.Input
						label={t('password')}
						placeholder={t('password')}
						name="agentPassword"
						value={state.agentPassword}
						autoComplete="new-password"
						onChange={handleChange}
						error={state.passworderror ? { content: t('passwordValid'), pointing: 'above' } : false}
						required={!IS_UPDATE}
						type="text"
					/>
				</Form.Group>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button type="button" basic size="small" content={t('cancel')} onClick={reset} />
					<Button type="submit" positive size="small" icon={IS_UPDATE ? 'save' : 'plus'} content={state.addButton} />
				</div>
			</Form>
		);
	}

	function renderViewerForm() {
		return (
			<Form
				size="small"
				error={!!state.errorviewer}
				autoComplete="off"
				onSubmit={() => {
					if (!IS_UPDATE_VIEWER) handleAddViewer();
					else handleUpdateViewer();
				}}
			>
				<input autoComplete="false" name="" value="" type="email" style={{ display: 'none' }} />
				{state.errorviewer && <Message error size="small" content={'' + state.errorviewer} />}
				<Form.Group widths="equal">
					<Form.Input label={t('email')} placeholder="Email" name="agentMail" value={state.agentMail} onChange={handleChange} required type="email" />
					<Form.Input label={t('type')} name="agentType" value={t('viewer')} readOnly type="text" />
					<Form.Input
						label={t('fullName')}
						placeholder={t('fullName')}
						name="agentName"
						value={state.agentName}
						onChange={handleChange}
						required={!IS_UPDATE_VIEWER}
						type="text"
					/>
					<Form.Input
						label={t('password')}
						placeholder={t('password')}
						name="agentPassword"
						value={state.agentPassword}
						autoComplete="new-password"
						onChange={handleChange}
						error={state.passworderror ? { content: t('passwordValid'), pointing: 'above' } : false}
						required={!IS_UPDATE_VIEWER}
						type="text"
					/>
				</Form.Group>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button type="button" basic size="small" content={t('cancel')} onClick={reset} />
					<Button type="submit" positive size="small" icon={IS_UPDATE_VIEWER ? 'save' : 'plus'} content={state.addButton} />
				</div>
			</Form>
		);
	}

	const IS_UPDATE = state.current === 'update';
	const IS_UPDATE_VIEWER = state.currentviewer === 'update';

	// Grup seçenekleri: telefon grupları (phone_<id>) + admin tarafında elle tanımlı gruplar
	const phone_groups = (pg && pg.phone_groups) || [];
	const phoneGroupsEnabled = phone_groups.length > 0;
	const manual_groups = _.filter((pg && pg.groups) || [], (g) => g && g.id && !/^phone_/.test(g.id));
	const groupOptions = _.concat(
		_.map(phone_groups, (p) => ({ key: 'phone_' + p.id, value: 'phone_' + p.id, text: p.label || String(p.id), icon: 'phone' })),
		_.map(manual_groups, (g) => ({ key: g.id, value: g.id, text: g.label || g.id, icon: 'users' }))
	);
	const showGroups = groupOptions.length > 0;
	const multiOn = !!(pg && pg.maytapi_multi && pg.webhook_multi);
	function agentGroupList(live_chat_agent) {
		return (live_chat_agent && live_chat_agent.group && _.compact(live_chat_agent.group.split(','))) || [];
	}
	function renderGroups(live_chat_agent) {
		let list = agentGroupList(live_chat_agent);
		if (!list.length) return '';
		return _.map(list, (id) => {
			let opt = _.find(groupOptions, { value: id });
			return (
				<Label key={id} size="tiny" basic style={{ margin: '1px' }}>
					{opt ? opt.text : id}
				</Label>
			);
		});
	}
	async function listWhatsappPhones() {
		let wapi_token = product && product.settings && product.settings.wapi_token;
		if (!product || !wapi_token) throw new Error(t('phoneGroupsNoWapi'));
		let data = await toWapi(`/api/${product.id}/listPhones`, wapi_token);
		// live-chat getPhoneList ile aynı: henüz QR okutulmamış (idle) telefonlar da listelenir, grup id telefon id'sine dayanır
		let phones = _.filter(
			data && data.data,
			(it) => it && it.type !== 'instagram' && it.type !== 'telegram' && (it.number || it.status === 'idle') && it.status !== 'disabled'
		);
		return _.map(_.orderBy(phones, 'id'), (it) => ({ id: it.id, label: it.name || it.number || '#' + it.id }));
	}
	async function updatePhoneGroups(body) {
		setPgLoading(true);
		setPgError(null);
		try {
			let res = await post('/dahi/message/updatePhoneGroups', body);
			let data = res && res.data;
			if (!data || !data.success) throw new Error((data && data.message) || 'Error');
			setReload((r) => r + 1);
		} catch (error) {
			setPgError(error.message);
		}
		setPgLoading(false);
	}
	async function syncPhoneGroups(enable) {
		setPgLoading(true);
		setPgError(null);
		try {
			let list = await listWhatsappPhones();
			if (!list.length) throw new Error(t('phoneGroupsNoPhone'));
			// açarken multi de otomatik açılır: aynı kişi farklı numaralara yazınca ayrı konuşma
			await updatePhoneGroups(enable ? { list, multi: true } : { list });
		} catch (error) {
			setPgError(error.message);
			setPgLoading(false);
		}
	}
	function togglePhoneGroups(checked) {
		if (checked) syncPhoneGroups(true);
		else updatePhoneGroups({ list: [] });
	}
	return (
		<Page
			header={
				<Breadcrumb size="big">
					<Breadcrumb.Section as={Link} to={`/settings`}>
						<Icon name="setting" />
						{t('settings')}
					</Breadcrumb.Section>
					<Breadcrumb.Divider icon="right chevron" />
					<Breadcrumb.Section>{t('agents')}</Breadcrumb.Section>
				</Breadcrumb>
			}
			extra={
				<div className="ml-auto">
					<AccountProgress></AccountProgress>
				</div>
			}
			flex
		>
			<MyMenu activeItem="agent">
				<Page.Wrap>
					<Segment>
						{state.addError ? (
							<Message error>
								<p>
									{state.addErrorMessage}
									{host ? <Link to="/settings/subscription"> {t('goToSubscription')}</Link> : ' ' + t('Plasecontacttoyouradmin')}
								</p>
							</Message>
						) : (
							''
						)}
						<div className="d-flex" style={{ alignItems: 'center', marginBottom: '0.75em' }}>
							<h3 style={{ margin: 0 }}>
								{t('agents')}{' '}
								<Label basic size="small" style={{ marginLeft: '0.5em' }}>
									{agentcount} / {agentlimit}
								</Label>
							</h3>
							{!own_team_admin && (
								<Button positive size="small" icon="plus" content={t('addAgent')} className="ml-auto" onClick={() => handleAddAgents()} />
							)}
						</div>
						<Table unstackable>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell width="5">{t('email')}</Table.HeaderCell>
									<Table.HeaderCell width="2">{t('type')}</Table.HeaderCell>
									<Table.HeaderCell width="3">{t('name')}</Table.HeaderCell>
									<Table.HeaderCell width="3">{isTeam ? t('team') : showGroups ? t('groups') : ''}</Table.HeaderCell>
									<Table.HeaderCell width="1" textAlign="center">
										{t('activeSessions')}
									</Table.HeaderCell>
									<Table.HeaderCell width="2"></Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{state.current === 'add' && (
									<Table.Row active>
										<Table.Cell colSpan="6">{renderAgentForm()}</Table.Cell>
									</Table.Row>
								)}
								{!own_team_admin && (
									<Table.Row key={'owner'}>
										<Table.Cell>{user.email}</Table.Cell>
										<Table.Cell>{t('owner')}</Table.Cell>
										<Table.Cell>{user.name || t('enterName')}</Table.Cell>
										<Table.Cell>{t('owner')}</Table.Cell>
										<Table.Cell textAlign="center">{renderSessions(user.id)}</Table.Cell>
										<Table.Cell></Table.Cell>
									</Table.Row>
								)}
								{_.map(agentsData, (data, index) => {
									let live_chat_agent = _.find(live_chat_agents, (it) => it.id === data.extra.user_id);
									let team = live_chat_agent && live_chat_agent.team;
									let team_admin = live_chat_agent && live_chat_agent.team_admin;
									let team_text = (team && _.find(isTeam, { id: team })) || '';
									// takım admini sadece kendi takımını görür
									if (own_team_admin && own_team && own_team !== team) return null;
									let editing = IS_UPDATE && state.selectedAgentUid === data.id;
									let over_limit = index + 2 > agentlimit;
									return (
										<React.Fragment key={data.id || index}>
											<Table.Row active={editing}>
												<Table.Cell>
													{data.email}
													{over_limit && (
														<Popup
															content={t('agentDontUseChat')}
															trigger={<Icon name="warning sign" color="red" style={{ marginLeft: '0.5em' }} />}
														/>
													)}
												</Table.Cell>
												<Table.Cell>{(_.upperFirst(data.role) || t('owner')) + (team_admin ? ' - Takım Admin' : '')}</Table.Cell>
												<Table.Cell>{data.name}</Table.Cell>
												<Table.Cell>{team ? (team_text ? team_text.label : team) : renderGroups(live_chat_agent)}</Table.Cell>
												<Table.Cell textAlign="center">{renderSessions(data.uid)}</Table.Cell>
												<Table.Cell textAlign="right" style={{ whiteSpace: 'nowrap' }}>
													{data.type !== 'admin' && (
														<Button.Group size="tiny">
															<Button
																icon="edit"
																primary
																title={t('update')}
																onClick={() =>
																	editing
																		? reset()
																		: handleUpdateAgents({
																				mail: data.email,
																				agentType: data.role,
																				uid: data.id,
																				name: data.name,
																				password: data.password,
																				user_id: data.extra.user_id,
																				groups: agentGroupList(live_chat_agent),
																		  })
																}
															/>
															<Button
																icon="trash"
																negative
																title={t('delete')}
																onClick={() => openDeleteButton({ uid: data.uid, email: data.email, user_id: data.extra.user_id })}
															/>
														</Button.Group>
													)}
												</Table.Cell>
											</Table.Row>
											{editing && (
												<Table.Row active>
													<Table.Cell colSpan="6">{renderAgentForm()}</Table.Cell>
												</Table.Row>
											)}
										</React.Fragment>
									);
								})}
							</Table.Body>
						</Table>
					</Segment>
					<Message info>
						<p>
							{t('owner')}: {t('ownerDesc')}
						</p>
						<p>
							{t('admin')}: {t('adminDesc')}
						</p>
						<p>Standard: {t('standardDesc')}</p>
						<p>
							{t('agent')}: {t('agentDesc')}
						</p>
					</Message>
					{!own_team_admin && pg && pg.enabled && (
						<Segment loading={pgLoading}>
							<h3>{t('phoneGroups')}</h3>
							<p>{t('phoneGroupsDesc')}</p>
							<Checkbox toggle label={t('phoneGroupsEnable')} checked={phoneGroupsEnabled} onChange={(e, { checked }) => togglePhoneGroups(checked)} />
							{phoneGroupsEnabled && (
								<div style={{ marginTop: '1em' }}>
									<Message info size="small" icon="info circle" content={t('phoneGroupsBoundWarning')} />
									<Checkbox
										toggle
										label={t('phoneGroupsMulti')}
										checked={multiOn}
										disabled={pg.webhook_custom}
										onChange={(e, { checked }) => updatePhoneGroups({ multi: checked })}
									/>
									{!multiOn && <Message warning size="small" content={t('phoneGroupsMultiWarning')} />}
									{pg.webhook_custom && <Message warning size="small" content={t('phoneGroupsCustomWebhook') + ' ' + pg.webhook} />}
									<Table compact size="small">
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell>{t('phoneGroupsPhone')}</Table.HeaderCell>
												<Table.HeaderCell>{t('phoneGroupsGroupId')}</Table.HeaderCell>
												<Table.HeaderCell>{t('agents')}</Table.HeaderCell>
												<Table.HeaderCell textAlign="right">
													<Button size="tiny" basic icon="refresh" content={t('phoneGroupsSync')} onClick={() => syncPhoneGroups(false)} />
												</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{_.map(phone_groups, (p) => {
												let gid = 'phone_' + p.id;
												let members = _.filter(live_chat_agents, (a) => _.includes(agentGroupList(a), gid));
												return (
													<Table.Row key={gid}>
														<Table.Cell>{p.label || p.id}</Table.Cell>
														<Table.Cell>
															<code>{gid}</code>
														</Table.Cell>
														<Table.Cell>{members.length ? _.map(members, (a) => a.developer).join(', ') : <span style={{ opacity: 0.5 }}>-</span>}</Table.Cell>
														<Table.Cell></Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								</div>
							)}
							{pgError && <Message negative size="small" content={pgError} />}
						</Segment>
					)}
					<Segment>
						<div className="d-flex" style={{ alignItems: 'center', marginBottom: '0.75em' }}>
							<h3 style={{ margin: 0 }}>
								{t('viewers')}{' '}
								<Label basic size="small" style={{ marginLeft: '0.5em' }}>
									{viewerscount} / 10
								</Label>
							</h3>
							<Button positive size="small" icon="plus" content={t('addViewers')} className="ml-auto" onClick={() => handleAddViewers()} />
						</div>
						<Table unstackable>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell width="5">{t('email')}</Table.HeaderCell>
									<Table.HeaderCell width="2">{t('type')}</Table.HeaderCell>
									<Table.HeaderCell width="3">{t('name')}</Table.HeaderCell>
									<Table.HeaderCell width="3"></Table.HeaderCell>
									<Table.HeaderCell width="1" textAlign="center">
										{t('activeSessions')}
									</Table.HeaderCell>
									<Table.HeaderCell width="2"></Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{state.currentviewer === 'add' && (
									<Table.Row active>
										<Table.Cell colSpan="6">{renderViewerForm()}</Table.Cell>
									</Table.Row>
								)}
								{_.map(viewersData, (data, index) => {
									let editing = IS_UPDATE_VIEWER && state.selectedAgentUid === data.id;
									return (
										<React.Fragment key={data.id || index}>
											<Table.Row active={editing}>
												<Table.Cell>{data.email}</Table.Cell>
												<Table.Cell>{_.upperFirst(data.role) || 'Owner'}</Table.Cell>
												<Table.Cell>{data.name}</Table.Cell>
												<Table.Cell></Table.Cell>
												<Table.Cell textAlign="center">{renderSessions(data.uid)}</Table.Cell>
												<Table.Cell textAlign="right" style={{ whiteSpace: 'nowrap' }}>
													{data.type !== 'admin' && (
														<Button.Group size="tiny">
															<Button
																icon="edit"
																primary
																title={t('update')}
																onClick={() =>
																	editing
																		? reset()
																		: handleUpdateViewers({
																				mail: data.email,
																				agentType: data.role,
																				uid: data.id,
																				name: data.name,
																				password: data.password,
																				user_id: data.extra.user_id,
																		  })
																}
															/>
															<Button
																icon="trash"
																negative
																title={t('delete')}
																onClick={() => openDeleteButton({ uid: data.uid, email: data.email, user_id: data.extra.user_id })}
															/>
														</Button.Group>
													)}
												</Table.Cell>
											</Table.Row>
											{editing && (
												<Table.Row active>
													<Table.Cell colSpan="6">{renderViewerForm()}</Table.Cell>
												</Table.Row>
											)}
										</React.Fragment>
									);
								})}
							</Table.Body>
						</Table>
					</Segment>
					<Message info>
						<p>
							{t('viewer')}: {t('viewerDesc')}
						</p>
					</Message>
				</Page.Wrap>
			</MyMenu>

			{/*delete modal*/}
			<Modal open={state.deleteBtnClicked} onClose={() => closeDeleteButton()} style={{ width: 500 }}>
				<Header icon="trash" content={t('deleteAgentModal')} />
				<Modal.Content>
					<p>{t('deleteAgentQuestion')}</p>
				</Modal.Content>
				<Modal.Actions>
					<Button color="red" onClick={() => closeDeleteButton()}>
						<Icon name="remove" /> {t('no')}
					</Button>
					<Button color="green" onClick={() => handleClickDelete()}>
						<Icon name="checkmark" /> {t('yes')}
					</Button>
				</Modal.Actions>
			</Modal>
		</Page>
	);
}
